import { render, staticRenderFns } from "./zbht.vue?vue&type=template&id=74063472&scoped=true"
import script from "./zbht.vue?vue&type=script&lang=js"
export * from "./zbht.vue?vue&type=script&lang=js"
import style0 from "./zbht.vue?vue&type=style&index=0&id=74063472&prod&scoped=true&lang=scss"
import style1 from "./zbht.vue?vue&type=style&index=1&id=74063472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74063472",
  null
  
)

export default component.exports